<template>
  <div :class="operation.actualOperation ? 'owned-by-investor' : ''" class="card-item transaction shadowless">
    <div id="process-result-item" class="entity-main-data">
      <div class="item">
        <span class="title"> Operación </span>
        <span>{{ operation.companyOperationId }}</span>
      </div>
      <div class="item">
        <span class="title"> Primera Cuota </span>
        <div>
          <b-tag rounded type="is-primary" class="bold">{{ operation.firstPaymentNumber }}</b-tag>
          <b-tag type="is-medium is-white"> {{ formatDate(operation.firstPaymentDueDate) }} </b-tag>
        </div>
      </div>
      <div class="item">
        <span class="title"> Nro. de Cuotas </span>
        <span>{{ operation.paymentsQuantity }}</span>
      </div>
      <div class="item">
        <span class="title"> Valor </span>
        <span>UF {{ formatNumber(operation.paymentsSum) }}</span>
      </div>
      <div class="check-button">
        <a
          :id="`check-button-${pos}`"
          href="#"
          class="text-not-underline"
          @click.prevent="showDetails(pos)">
          <span class="icon">
            <i
              class="fas fa-chevron-up transition-slow"
              :class="{rotate: extendedEntity !== pos}" />
          </span>
        </a>
      </div>
    </div>
    <div
      :id="`extended-detail-${pos}`"
      class="entity-detailed-data content transition-slow"
      :class="{ show: extendedEntity === pos }">
      <operation-payment-detail
        v-for="(payment, i) in paymentsArray"
        :id="`item-${i}`"
        :key="`${payment}-${i}`"
        :operation-id="operation._id"
        :show-payment="showPaymentState"
        :payment="payment"
        :pos="i"
        :class="showPaymentState? 'entity-details-4-cols' : 'entity-details-3-cols'"
        :style="{ '--i': i }" />
    </div>
  </div>
</template>

<script>
import Roles from '@/domain/rolesEnum';
import OperationPaymentDetail from '@/ui/views/internal/my-portfolios/OperationPaymentDetail.vue';
import { formatNumber } from '@/infrastructure/format';
import { getPaymentsByOperationIdAndInvestorsIds } from '@/application/services/api-clients/operations';

export default {
  name: 'OperationItem',
  components: { OperationPaymentDetail },
  props: {
    showPayment: {
      type: Boolean,
      default: false,
      required: false
    },
    investorsIds: {
      type: Array
    },
    operation: {
      type: Object,
      default: () => {},
      required: true
    },
    pos: {
      type: Number,
      required: true
    },
    showAllPayments: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      extendedEntity: undefined,
      paymentsArray: [],
      showPaymentState: false
    };
  },
  async mounted() {
    const { user: { rol } } = this.$store.state.currentUser;
    if (rol === Roles.INSTITUCIONAL_VENDOR) {
      this.showPaymentState = true;
    }
  },
  methods: {
    formatNumber: number => formatNumber({ number }),
    async showDetails(pos) {
      this.extendedEntity = this.extendedEntity !== pos ? pos : undefined;
      const payments = await getPaymentsByOperationIdAndInvestorsIds(this.operation._id, this.investorsIds);
      this.paymentsArray = payments[0].payments;
      this.sendFilterAction('show_details');
    },
    formatDate: date => {
      const dateSlice = date.split('-');
      return `${dateSlice[1]}-${dateSlice[0]}`;
    },
    async sendFilterAction(actionFront) {
      try {
        const { currentUser } = this.$store.state;
        const { user } = currentUser;
        const action = {
          country: this.$i18n.locale,
          view: this.$route.name,
          user_id: user._id,
          user_rol: user.rol,
          executed_at: new Date(),
          action: actionFront
        };
        if (user.rol === 'INVESTOR' && user.investorsIds) {
          action.metadata = { investorsIds: user.investorsIds };
        }
        // await this.$socket.emit('action', action);
      } catch (_error) {
        // console.log('Error al enviar action filter', error);
      }
    }
  }
};
</script>

<style scoped>
.tag-and-counter {
  display: inline-flex;
}
.text-not-underline {
  text-decoration: none !important;
}
.entity-main-data {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  font-size: 1rem;
}
.entity-main-data .item {
  display: grid;
  justify-content: stretch;
  margin: 0;
}
.entity-main-data .item .title {
  font-size: 0.8rem;
  margin: 0;
}

.entity-detailed-data {
  width: 100%;
  max-height: 0px;
  height: auto;
  overflow: hidden;
  background-color: #f9f9f9;
  border-radius: 20px;
  padding: 0 30px;
  margin: 0px auto auto;
  font-size: 14px;
}
.entity-details-3-cols {
  display: grid;
  gap: 0.3rem 1rem;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-columns: repeat(3, minmax(150px, 1fr));
  grid-template-areas: "col1 col2 col3";
  text-align: center;
  font-size: 0.8rem;
}
.entity-details-4-cols {
  display: grid;
  gap: 0.3rem 1rem;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-columns: repeat(4, minmax(150px, 1fr));
  grid-template-areas: "col1 col2 col3";
  text-align: center;
  font-size: 0.8rem;
}
.entity-details .item {
  display: flex;
  align-items: left;
  margin: auto;
}
.entity-details .item .title {
  font-size: 0.7rem;
  margin: 0;
}
.show {
  margin-top: 10px;
  padding: 20px;
  max-height: 600px;
  overflow-y: auto;
}
.is-disabled {
  opacity: 0.5;
}
.rotate {
  transform: rotate(180deg);
}
.owned-by-investor {
  border: 1px solid var(--primary);
}

@media (max-width: 640px) {
  .entity-main-data {
    display: block;
    text-align: center;
  }
  .entity-main-data > div {
    margin-bottom: 10px;
    display: block;
  }
  .entity-main-data .item {
    display: block;
    justify-content: stretch;
    margin-bottom: 10px;
  }
  .entity-main-data .item > span {
    margin-left: 5px;
  }
  .movement-type.field.is-grouped {
    display: block;
  }
  .entity-details {
    grid-template-columns: repeat(1, 1fr);
    grid-template-areas: "col1";
  }
  .entity-details .item {
    display: inline-block;
    width: 100%;
    align-items: center;
    grid-template-columns: repeat(2, minmax(150px, 1fr));
    text-align: center;
    padding: 5px;
  }
  .entity-details .item .button{
    display: inline-block;
    width: 100%;
  }
}
</style>
